import React from 'react'
import moment from 'moment'

import {
    Dialog,
    DialogTitle,
    DialogContent,
    Button,
    Checkbox,
} from '@material-ui/core'

import './index.scss'

class Appointment extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            appointmentDataAlt: {
                checkBox: false,
                phoneNumber: '',
            },
        }

        this.dateRef = React.createRef()
        this.timeRef = React.createRef()
        this.phoneRef = React.createRef()
        this.checkBoxRef = React.createRef()
        this.onDateChange = this.onDateChange.bind(this)
        this.onCheckBoxChange = this.onCheckBoxChange.bind(this)
        this.onTimeChange = this.onTimeChange.bind(this)
        this.onSave = this.onSave.bind(this)
        this.onPhoneChange = this.onPhoneChange.bind(this)
        this.onClear = this.onClear.bind(this)
    }

    componentDidMount() {
        const { appointmentData, appointmentDataAlt } = this.state
        let isDate
        let isPhone
        let isCheckbox
        if (this.props.inputForm) {
            isDate = this.props.inputForm.find(el => el.input === 'date') !== undefined
            isPhone = this.props.inputForm.find(el => el.input === 'phone') !== undefined
            isCheckbox = this.props.inputForm.find(el => el.input === 'checkbox') !== undefined
        }
        if (!isPhone && !isCheckbox) {
            isDate = true
        }

        const forms = { isDate, isPhone, isCheckbox }

        if (!appointmentData && this.props.appointmentData) {
            const apptDataParsed = JSON.parse(this.props.appointmentData)
            if (isDate) {
                const date = apptDataParsed.datetime

                appointmentDataAlt.date = moment(date).format('YYYY-MM-DD')
                appointmentDataAlt.time = moment(date).format('HH:mm')
            }
            if (isPhone) {
                appointmentDataAlt.phoneNumber = apptDataParsed.phoneNumber
            }
            if (isCheckbox) {
                appointmentDataAlt.checkBox = apptDataParsed.appointmentRequested
            }
            this.setState({
                appointmentData: apptDataParsed,
                appointmentDataAlt,
                forms,
            })
        }

        if (!appointmentDataAlt.date || !appointmentDataAlt.time) {
            const date = moment().format('YYYY-MM-DD')
            appointmentDataAlt.date = date

            const time = moment().format('HH:mm')
            appointmentDataAlt.time = time

            this.setState({ appointmentDataAlt, forms })
        }
    }

    onDateChange() {
        const newDate = this.dateRef.current.value

        const { appointmentDataAlt } = this.state

        appointmentDataAlt.date = newDate

        this.setState({ appointmentDataAlt }, () => {
            console.log(this.state.appointmentDataAlt)
        })
    }

    onTimeChange() {
        const newTime = this.timeRef.current.value

        const { appointmentDataAlt } = this.state

        appointmentDataAlt.time = newTime
        this.setState({ appointmentDataAlt })
    }

    onPhoneChange() {
        const newNumber = this.phoneRef.current.value
        const { appointmentDataAlt } = this.state

        appointmentDataAlt.phoneNumber = newNumber
        this.setState({ appointmentDataAlt })
    }

    onCheckBoxChange(e) {
        const newVal = e.target.checked
        const { appointmentDataAlt } = this.state
        appointmentDataAlt.checkBox = newVal
        this.setState({ appointmentDataAlt })
    }

    onSave() {
        let dateValue
        if (this.dateRef && this.dateRef.current) {
            dateValue = this.dateRef.current.value
        }

        let timeValue
        if (this.timeRef && this.timeRef.current) {
            timeValue = this.timeRef.current.value
        }

        const datetime = `${dateValue}T${timeValue}:00.000`
        const datetimeObj = moment(datetime)

        const objToSave = {}
        if (datetimeObj < moment.utc().subtract(3, 'days')) {
            // eslint-disable-next-line no-alert
            alert('Cannot set appointment in past!')

            return
        }

        let { leadInfo } = this.props
        if (leadInfo) {
            leadInfo = JSON.parse(leadInfo)
        }
        objToSave.datetime = datetime
        if (this.state.forms) {
            if (this.state.forms.isCheckbox && this.state.appointmentDataAlt) {
                objToSave.appointmentRequested = this.state.appointmentDataAlt.checkBox
            }
            if (this.state.forms.isPhone && this.phoneRef.current) {
                objToSave.phoneNumber = this.phoneRef.current.value
            }
        }

        this.props.onAppointmentUpdate({ ...objToSave })
    }

    onClear() {
        this.props.onAppointmentUpdate()
    }

    render() {
        const { leadInfo } = this.props

        return (
            <div className='Appointment'>
                <Dialog
                    open={true}
                    onClose={this.props.onClose}
                    aria-labelledby='form-dialog-title'
                >
                    <DialogTitle id='form-dialog-title'>
                        Appointment
                    </DialogTitle>
                    <DialogContent>
                        {!this.props.timeInWorkingHours(
                            this.state.appointmentDataAlt
                        ) && (
                            <div className='Appointment__error'>
                                Violating appointment conditions
                            </div>
                        )}
                        {leadInfo && (
                            <div className='Appointment__content'>
                                {this.state.forms && this.state.forms.isDate && (
                                    <>
                                        <input
                                            ref={this.dateRef}
                                            value={
                                                this.state.appointmentDataAlt
                                                    .date
                                            }
                                            type='date'
                                            // min={moment()
                                            //  .subtract(3, 'days')
                                            //  .format('YYYY-MM-DD')}
                                            onChange={this.onDateChange}
                                        />
                                        <input
                                            ref={this.timeRef}
                                            value={
                                                this.state.appointmentDataAlt
                                                    .time
                                            }
                                            type='time'
                                            onChange={this.onTimeChange}
                                        />
                                    </>
                                )}
                                {this.state.forms && this.state.forms.isPhone && (
                                    <div
                                        style={{
                                            display: 'block',
                                            padding: '3px',
                                        }}
                                    >
                                        Phone Number:
                                        <input
                                            ref={this.phoneRef}
                                            value={
                                                this.state.appointmentDataAlt
                                                    .phoneNumber
                                            }
                                            onChange={this.onPhoneChange}
                                        />{' '}
                                    </div>
                                )}
                                {this.state.forms
                                    && this.state.forms.isCheckbox
                                    && (
                                        <div style={{ display: 'block' }}>
                                            Appointment Requested:{' '}
                                            <Checkbox
                                                ref={this.checkBoxRef}
                                                checked={
                                                    this.state
                                                        .appointmentDataAlt
                                                        .checkBox
                                                }
                                                onChange={this.onCheckBoxChange}
                                            />
                                        </div>
                                    )}
                            </div>
                        )}
                        {!leadInfo && <p>No Lead Info!</p>}
                    </DialogContent>
                    {leadInfo && (
                        <div className='Appointment__div'>
                            <Button
                                color='secondary'
                                variant='contained'
                                onClick={this.onClear}
                            >
                                Clear
                            </Button>
                            <Button
                                color='primary'
                                onClick={this.onSave}
                                disabled={
                                    !this.props.timeInWorkingHours(
                                        this.state.appointmentDataAlt
                                    )
                                }
                            >
                                Save
                            </Button>
                        </div>
                    )}
                </Dialog>
            </div>
        )
    }
}

export default React.memo(Appointment)
